import { runtimeEnv } from 'config/runtimeEnv';
import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from '../utils/utils';

let env = runtimeEnv('B2B_API_BASE_URL');

export const tagApi = async (data) => {
  let url = `${env}${API_ENDPOINT.Tag.api}?type=${data?.type}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const addTagApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.Tag.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateTagApi = async (data) => {
  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.Tag.api + '/' + data.id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const ratingApi = async (data) => {
  const page = data?.page === 0 || data?.page ? data?.page + 1 : 1;
  let url = `${env}${API_ENDPOINT.Rating.api + '?type=' + data?.type + '&status=' + data?.status + '&dateFrom=' + data?.dateFrom + '&dateTo=' + data?.dateTo + '&page=' + page + '&pageSize=' + data?.pageSize}`;
  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};
